import React, {  useRef } from 'react'
import './Profile.css'
import Spinner from '../../utilities/spinner/Spinner'
import { validateFileType } from '../../utilities/fileReader/FileReader'

//svg
import SvgCamera from '../../svgIcons/SvgCamera'
//Redux
import { useSelector, useDispatch } from 'react-redux'
import { changeImage } from '../../redux'
function ImageSection() {
  const IMAGE_FORMATS = ['jpg', 'jpeg', 'png']

  const user = useSelector((state) => state.user)
  const inputRef = useRef()

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return
    }
    var selectedFile = e.target.files[0]
    if (selectedFile.size > 1000000) {
      e.target.value = null
      alert('size must be less thanb 1MB')
    } else if (validateFileType(selectedFile, IMAGE_FORMATS)) {
      dispatch(changeImage(selectedFile, user.credentials.image.name, user.credentials.id))
    } else {
      e.target.value = null
    }
  }

  let imageSectionMarkup =
    user.loading || !user.credentials.image.url ? (
      <Spinner />
    ) : (
      <>
        <img src={user.credentials.image.url} alt='profile' className='profile-image-style' />
        <SvgCamera onClick={() => inputRef.current.click()} />
        <input type='file' ref={inputRef} hidden accept='.jpg, .jpeg, .png' onChange={onSelectFile} />
      </>
    )

  const dispatch = useDispatch()
  return <div className='profile-image-container'>{imageSectionMarkup}</div>
}

export default ImageSection
